<template>
  <div>
    <div class="d-flex mt-2">
      <feather-icon icon="TruckIcon" size="19"/>
      <h4 class="mb-0 ml-50">
        {{ $t('Rfid Information')}}
      </h4>
    </div>
    <b-row class="mt-2">

      <b-col cols="12">
        <b-form-group :label="$t('Mac')">
          <b-input-group class="input-group-merge">
            <b-form-input v-model="rfidData.mac" :state="errors && ('mac' in errors) ? false : null"
                          :placeholder="$t('Mac')"/>
          </b-input-group>
          <small v-if="errors && ('mac' in errors)" class="text-danger">
            {{ $t(errors['mac'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('Device')">
          <v-select v-model="rfidData.device_id"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
              :getOptionLabel="d => d.name"
              :options="devices"
              :reduce="d => d.device_id"
          />
          <small v-if="errors && ('device_id' in errors)" class="text-danger">
            {{ $t(errors['device_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { getUserLinkedBy } from '@/api/userLinkedData'
import store from '@/store'
import { BButton, BCol, BForm, BFormGroup, BFormInput, BInputGroup, BRow } from 'bootstrap-vue'
import vSelect from 'vue-select'


export default {
  props: ['rfidData', 'errors'],
  components: { BRow, BCol, BFormGroup, BFormInput, BInputGroup, BForm, BButton, vSelect, },
  setup() {

    const devices = ref([])

    const params = {
      type: 'device',
      user: store.state.auth.userData.id,
      cols: 'device_id,name'
    }

    getUserLinkedBy(params).then(r =>
        devices.value = r.data.data)

    return {
      devices
    }
  }
}
</script>

<style scoped>

</style>
